import React from "react";

import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewAgendaOutlinedIcon from "@mui/icons-material/ViewAgendaOutlined";
import ViewListIcon from "@mui/icons-material/ViewList";
import { IconProps } from "@mui/material";
import { HorizontalNavBar } from "components/HorizontalNavBar/HorizontalNavBar";
import { DealViews } from "constants/deal";
import { useAccountSelector, useUserRoleSelector } from "store";
import { DealsQueries } from "store/types";

import { RoleName } from "../../../constants";

interface Props {
  value: DealsQueries["view"];
  onChange: (value: DealsQueries["view"]) => void;
  isPipelineAvailable: boolean;
}

const iconsSx: IconProps["sx"] = {
  fontSize: "16px",
  mr: "6px"
};

const rolesForHCSDashboard: RoleName[] = [RoleName.Admin, RoleName.Analyst, RoleName.Investor];

export const Views: React.FC<Props> = ({ value, onChange, isPipelineAvailable }) => {
  const { name: roleName } = useUserRoleSelector() || {};
  const { show_hcs_view } = useAccountSelector() || {};

  const isDashboardEnabled = show_hcs_view && roleName && rolesForHCSDashboard.includes(roleName as RoleName);

  return (
    <HorizontalNavBar
      value={value}
      tabs={[
        {
          label: "Dashboard",
          icon: <DashboardOutlinedIcon sx={iconsSx} />,
          value: DealViews.Dashboard,
          hidden: !isDashboardEnabled,
          onClick: () => onChange(DealViews.Dashboard)
        },
        {
          label: "Pipeline View",
          icon: <ViewAgendaOutlinedIcon sx={{ ...iconsSx, transform: "rotate(90deg)" }} />,
          value: DealViews.PIPELINE,
          hidden: !isPipelineAvailable,
          onClick: () => onChange(DealViews.PIPELINE)
        },
        {
          label: "Card View",
          icon: <GridViewIcon sx={iconsSx} />,
          value: DealViews.GRID,
          onClick: () => onChange(DealViews.GRID)
        },
        {
          label: "Deal List",
          icon: <ViewListIcon sx={iconsSx} />,
          value: DealViews.TABLE,
          onClick: () => onChange(DealViews.TABLE)
        }
      ]}
    />
  );
};
